import { Link } from 'react-router-dom';
import type { ModoCompra } from '@/types';
import { cn } from '@/lib/utils';

interface CheckoutModeSelectorProps {
  modo: ModoCompra;
  onChange: (modo: ModoCompra) => void;
  loggedIn: boolean;
}

export function CheckoutModeSelector({ modo, onChange, loggedIn }: CheckoutModeSelectorProps) {
  return (
    <div className="mb-6 grid gap-3 sm:grid-cols-2">
      <button
        type="button"
        onClick={() => onChange('invitado')}
        className={cn(
          'rounded-lg border p-4 text-left transition-colors',
          modo === 'invitado'
            ? 'border-brand-600 bg-brand-50'
            : 'border-surface-200 bg-white hover:border-surface-300',
        )}
      >
        <p className="font-semibold text-surface-900">Soy cliente nuevo</p>
        <p className="mt-1 text-xs text-surface-600">
          Te registramos en Alarcom con tus datos. Si ya compras con nosotros, entra con tu cuenta.
        </p>
      </button>

      <button
        type="button"
        onClick={() => loggedIn && onChange('cliente')}
        disabled={!loggedIn}
        className={cn(
          'rounded-lg border p-4 text-left transition-colors',
          modo === 'cliente'
            ? 'border-brand-600 bg-brand-50'
            : 'border-surface-200 bg-white hover:border-surface-300',
          !loggedIn && 'cursor-not-allowed opacity-60',
        )}
      >
        <p className="font-semibold text-surface-900">Con mi cuenta</p>
        {loggedIn ? (
          <p className="mt-1 text-xs text-surface-600">
            Pedido ligado a tu ficha de cliente en el sistema.
          </p>
        ) : (
          <p className="mt-1 text-xs text-surface-600">
            <Link to="/ingresar?redirect=/checkout" className="font-medium text-brand-700 hover:underline">
              Inicia sesión
            </Link>{' '}
            con tu correo o número de cuenta.
          </p>
        )}
      </button>
    </div>
  );
}
